const years = [
  { value: "2029", displayValue: "2029" },
  { value: "2028", displayValue: "2028" },
  { value: "2027", displayValue: "2027" },
  { value: "2026", displayValue: "2026" },
  { value: "2025", displayValue: "2025" },
  { value: "2024", displayValue: "2024" },
  { value: "2023", displayValue: "2023" },
  { value: "2022", displayValue: "2022" },
  { value: "2021", displayValue: "2021" },
  { value: "2020", displayValue: "2020" },
  { value: "2019", displayValue: "2019" },
  { value: "2018", displayValue: "2018" },
  { value: "2017", displayValue: "2017" },
  { value: "2016", displayValue: "2016" },
  { value: "2015", displayValue: "2015" },
  { value: "2014", displayValue: "2014" },
  { value: "2013", displayValue: "2013" },
  { value: "2012", displayValue: "2012" },
  { value: "2011", displayValue: "2011" },
  { value: "2010", displayValue: "2010" },
  { value: "2009", displayValue: "2009" },
  { value: "2008", displayValue: "2008" },
  { value: "2007", displayValue: "2007" },
  { value: "2006", displayValue: "2006" },
  { value: "2005", displayValue: "2005" },
  { value: "2004", displayValue: "2004" },
  { value: "2003", displayValue: "2003" },
  { value: "2002", displayValue: "2002" },
  { value: "2001", displayValue: "2001" },
  { value: "2000", displayValue: "2000" },
  { value: "1999", displayValue: "1999" },
  { value: "1998", displayValue: "1998" },
  { value: "1997", displayValue: "1997" },
  { value: "1996", displayValue: "1996" },
  { value: "1995", displayValue: "1995" },
  { value: "1994", displayValue: "1994" },
  { value: "1993", displayValue: "1993" },
  { value: "1992", displayValue: "1992" },
  { value: "1991", displayValue: "1991" },
  { value: "1990", displayValue: "1990" },
  { value: "1989", displayValue: "1989" },
  { value: "1988", displayValue: "1988" },
  { value: "1987", displayValue: "1987" },
  { value: "1986", displayValue: "1986" },
  { value: "1985", displayValue: "1985" },
  { value: "1984", displayValue: "1984" },
  { value: "1983", displayValue: "1983" },
  { value: "1982", displayValue: "1982" },
  { value: "1981", displayValue: "1981" },
  { value: "1980", displayValue: "1980" },
  { value: "1979", displayValue: "1979" },
  { value: "1978", displayValue: "1978" },
  { value: "1977", displayValue: "1977" },
  { value: "1976", displayValue: "1976" },
  { value: "1975", displayValue: "1975" },
  { value: "1974", displayValue: "1974" },
  { value: "1973", displayValue: "1973" },
  { value: "1972", displayValue: "1972" },
  { value: "1971", displayValue: "1971" },
  { value: "1970", displayValue: "1970" },
  { value: "1969", displayValue: "1969" },
  { value: "1968", displayValue: "1968" },
  { value: "1967", displayValue: "1967" },
  { value: "1966", displayValue: "1966" },
  { value: "1965", displayValue: "1965" },
  { value: "1964", displayValue: "1964" },
  { value: "1963", displayValue: "1963" },
  { value: "1962", displayValue: "1962" },
  { value: "1961", displayValue: "1961" },
  { value: "1960", displayValue: "1960" },
  { value: "1959", displayValue: "1959" },
  { value: "1958", displayValue: "1958" },
  { value: "1957", displayValue: "1957" },
  { value: "1956", displayValue: "1956" },
  { value: "1955", displayValue: "1955" },
  { value: "1954", displayValue: "1954" },
  { value: "1953", displayValue: "1953" },
  { value: "1952", displayValue: "1952" },
  { value: "1951", displayValue: "1951" },
  { value: "1950", displayValue: "1950" },
  { value: "1949", displayValue: "1949" },
  { value: "1948", displayValue: "1948" },
  { value: "1947", displayValue: "1947" },
  { value: "1946", displayValue: "1946" },
  { value: "1945", displayValue: "1945" },
  { value: "1944", displayValue: "1944" },
  { value: "1943", displayValue: "1943" },
  { value: "1942", displayValue: "1942" },
  { value: "1941", displayValue: "1941" },
  { value: "1940", displayValue: "1940" },
  { value: "1939", displayValue: "1939" },
  { value: "1938", displayValue: "1938" },
  { value: "1937", displayValue: "1937" },
  { value: "1936", displayValue: "1936" },
  { value: "1935", displayValue: "1935" },
  { value: "1934", displayValue: "1934" },
  { value: "1933", displayValue: "1933" },
  { value: "1932", displayValue: "1932" },
  { value: "1931", displayValue: "1931" },
  { value: "1930", displayValue: "1930" },
  { value: "1929", displayValue: "1929" },
  { value: "1928", displayValue: "1928" },
  { value: "1927", displayValue: "1927" },
  { value: "1926", displayValue: "1926" },
  { value: "1925", displayValue: "1925" },
  { value: "1924", displayValue: "1924" },
  { value: "1923", displayValue: "1923" },
  { value: "1922", displayValue: "1922" },
  { value: "1921", displayValue: "1921" },
  { value: "1920", displayValue: "1920" },
  { value: "1919", displayValue: "1919" },
  { value: "1918", displayValue: "1918" },
  { value: "1917", displayValue: "1917" },
  { value: "1916", displayValue: "1916" },
  { value: "1915", displayValue: "1915" },
  { value: "1914", displayValue: "1914" },
  { value: "1913", displayValue: "1913" },
  { value: "1912", displayValue: "1912" },
  { value: "1911", displayValue: "1911" },
  { value: "1910", displayValue: "1910" },
  { value: "1909", displayValue: "1909" },
  { value: "1908", displayValue: "1908" },
  { value: "1907", displayValue: "1907" },
  { value: "1906", displayValue: "1906" },
  { value: "1905", displayValue: "1905" },
  { value: "1904", displayValue: "1904" },
  { value: "1903", displayValue: "1903" },
  { value: "1902", displayValue: "1902" },
  { value: "1901", displayValue: "1901" },
  { value: "1900", displayValue: "1900" },
];

export default years;
